import * as React from 'react';
import { TabButtonProps } from './types';
import { contentPanelId, labelId } from './selectors';

import style from './tabs.scss';

export class TabButton extends React.PureComponent<TabButtonProps> {

  public onChange = (event: React.MouseEvent) => {

    event.preventDefault();

    const { option, onChange } = this.props;
    onChange && onChange(option);
  };

  public render() {

    const { id, option: { description, value }, readOnly, selected } = this.props;

    return <li>
      {readOnly
        ? <span className={selected ? style.readOnlyActive : style.readOnly}
          id={labelId(id, value)}
          aria-selected={selected}
          aria-controls={selected ? contentPanelId(id) : undefined}
          role="tab">
          {description}
        </span>
        : <a href="#" className={selected ? style.active : style.selectable} onClick={this.onChange}
          id={labelId(id, value)}
          aria-selected={selected}
          aria-controls={selected ? contentPanelId(id) : undefined}
          role="tab">
          {description}
        </a>}
    </li>;
  }
}
